import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@material-ui/core"
import {ExpandMore as ExpandMoreIcon, IndeterminateCheckBox as RemoveEmailIcon} from "@material-ui/icons"
import React from "react"

import {CustomerEmailUpdateActivityPayload, CustomerEmailUpdateByCustomerActivityPayload} from "@indebted/api"

function EmailRemovedActivity(
	panelId: number,
	{
		Title,
		HappenedAt,
		Payload,
	}: {
		Title: string
		HappenedAt: string
		Payload: CustomerEmailUpdateActivityPayload | CustomerEmailUpdateByCustomerActivityPayload
	},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
) {
	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<RemoveEmailIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						<div>
							<Typography className={classes.activityContentLabel}>Email:</Typography>
							<Typography className={classes.activityContentValue}>{Payload.Email}</Typography>
						</div>
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {EmailRemovedActivity}
